import * as mutation from "./mutation-types";
import { getBlankDetails, getBlankAppSettings, getBlankSapConfigurationRecord } from "./helpers";

export const state = {
  details: getBlankDetails(true),
  rebuild: {
    processing: false,
    error: {
      show: false,
      details: {},
      hideMutation: mutation.STATE_HIDE_ERROR,
      hideArgument: "rebuild"
    }
  },
  globalError: {
    show: false,
    details: {}
  },
  clearProviders: {
    clearing: false
  },
  invoiceSeeding: {
    processing: false
  },
  appSettings: {
    loading: false,
    loaded: false,
    data: getBlankAppSettings()
  },
  sapConfiguration: {
    loading: false,
    loaded: false,
    levyCollectionType: null,
    data: getBlankSapConfigurationRecord()
  }
};
